import { Component } from "@angular/core";
import { NewShelfPage } from "../newShelf/newShelf";
import { Events } from "ionic-angular";
import { AlertController } from "ionic-angular/components/alert/alert-controller";
import { WhiskyDB } from "../../data/db";
import { SublistPage } from "../sublist/sublist";
import { ModalController } from "ionic-angular/components/modal/modal-controller";
//import { WhiskyDB_fb } from "../../data/fbDb";

@Component({
  selector: "page-shelves",
  templateUrl: "shelves.html"
})
export class ShelvesPage {
  newShelfPage: any;
  sublistPage: any;

  constructor(
    public events: Events,
    private alertCtrl: AlertController,
    private modalCtrl: ModalController
  ) {
    this.initializeItems();
    this.newShelfPage = NewShelfPage;
    this.sublistPage = SublistPage;

    // Update event
    this.events.subscribe("shelf:updated", () => {
      console.log("Got shelf:updated event");
      // Reapply fiters
      if (this.lastFilter == null) {
        this.items = WhiskyDB.getShelves();
      } else {
        this.getItems(this.lastFilter);
      }
    });

    this.events.subscribe("shelf:add", item => {
      WhiskyDB.addShelf(item);
//      WhiskyDB.shelves.push(item);
      this.events.publish("shelf:save");
      this.events.publish("shelf:updated");
    });

    this.events.subscribe("shelf:save", () => {
      console.log("Got shelf:save event");
      WhiskyDB.db.saveShelves();
    });
  }

  searchQuery: string = "";
  items: any[] ;
  lastFilter: any = null;

  initializeItems() {
    // Initial list is unfiltered
    this.items = WhiskyDB.getShelves();
  }

  getItems(ev: any) {
    // Sve the filter
    this.lastFilter = ev;

    // Reset items back to all of the items
    this.items = WhiskyDB.getShelves();

    // set val to the value of the searchbar
    let val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() != "") {
      console.log("Filter=" + val);
      this.items = WhiskyDB.getShelves().filter(item => {
        return item.shelf.toLowerCase().indexOf(val.toLowerCase()) > -1;
      });
    }
  }

  remove(toRemove: any, slider: any) {
    slider.close();
    let alert = this.alertCtrl.create({
      title: "Remove Shelf?",
      subTitle: toRemove,
      cssClass: "removeAlert",
      buttons: [
        {
          text: "Cancel",
          role: "Cancel",
          handler: () => {
            console.log("Cancel remove");
          }
        },
        {
          text: "Remove",
          cssClass: "remove-button",
          handler: () => {
            // Remove selected items
            console.log("Remove: " + toRemove);
            // Remove is via a filter
            WhiskyDB.removeShelf(toRemove);

            // Save them
            this.events.publish("shelf:save");
            this.events.publish("shelf:updated");
          }
        }
      ]
    });
    alert.present();
  }

  editItem(item, slider) {
    slider.close();
    let prompt = this.alertCtrl.create({
      title: "Edit Shelf",
      inputs: [
        {
          name: "Shelf",
          value: item,
        }
      ],
      buttons: [
        {
          text: "Cancel"
        },
        {
          text: "Save",
          handler: data => {
            let index = this.items.indexOf(item);

            if (index > -1) {
              this.items[index] = data.Shelf;
              console.log("Old: " + item + " new: " + data.Shelf);
              WhiskyDB.getShelves()[index] = data.Shelf;
              WhiskyDB.db.saveShelves();

              WhiskyDB.whisky.forEach(w => {
                if(w.shelves[0] === item)
                  w.shelves[0] = data.Shelf;
                if(w.shelves[1] === item)
                  w.shelves[1] = data.Shelf;
              });

              WhiskyDB.db.saveWhisky();
              this.events.publish("whisky:updated");

            }
          }
        }
      ]
    });

    prompt.present();
  }

  select(item) {
    let modal = this.modalCtrl.create(this.sublistPage, {
      title: item,
      type: "shelf",
      shelf: item
    });
    modal.present();

    //this.navCtrl.push(this.sublistPage, {title: item, type: "shelf", shelf: item})
  }
}



// WEBPACK FOOTER //
// ./src/pages/shelves/shelves.ts